// Mock data for Au 4A restaurant website

export const mockData = {
  restaurant: {
    name: "Au 4A",
    location: "Antheit, Belgique",
    chef: "Camie Piraprez",
    phone: "+32 476 24 90 68",
    email: "camiepiraprez@hotmail.com",
    address: "Rue des Grandes Ruelles 4A, 4520 Antheit, Belgique",
  },

  currentMenu: {
    season: "PRINTEMPS 2026",
    amuse_bouche: "6 Mises en bouche",
    appetizer: {
      name: "Filet de Bar, à la plancha",
      description: "Poireaux confit, safran et chorizo, ciboulette",
      wine: "Domaine Morin-Langaran – Picpoul de Pinet 2023",
    },
    main: {
      name: "Linguine et gorgonzola",
      description: "Filet de volaille et noix, persil et piment d'Espelette",
      wine: "Domaine Les Yeuses, “Singulière“ Cinsault 2023, Languedoc",
    },
    dessert: {
      name: "Crème brulée à l'orange",
      description: "",
    },
    price: "60.00 €",
    note: "Menu all in, boissons comprises",
  },
  /*
    wineSelection: [
      {
        category: "Vins Blancs",
        wines: [
          {
            name: "Chardonnay Chablis 2022",
            region: "Bourgogne, France",
            price: "38€",
            description: "Notes minérales et florales"
          },
          {
            name: "Riesling Moselle 2023",
            region: "Allemagne",
            price: "32€",
            description: "Fruité et équilibré"
          },
          {
            name: "Sauvignon Blanc Loire 2023",
            region: "France",
            price: "28€",
            description: "Vif et aromatique"
          }]
      },
      {
        category: "Vins Rouges",
        wines: [
          {
            name: "Pinot Noir Gevrey-Chambertin 2021",
            region: "Bourgogne, France",
            price: "65€",
            description: "Élégant et complexe"
          },
          {
            name: "Merlot Bordeaux 2020",
            region: "France",
            price: "42€",
            description: "Rond et charnu"
          },
          {
            name: "Cabernet Sauvignon Languedoc 2022",
            region: "France",
            price: "35€",
            description: "Puissant et structuré"
          }
        ]
      }
    ],
  
    favorites: {
      title: "COUPS DE COEUR",
      intro: "Je tenais par ces petits coups de cœur remercier les différentes personnes qui, de près ou de moins près, ont contribué à ce que mon projet voie le jour.",
      supporters: [
        "Tout d'abord mon architecte, Jean-Christophe Deffet, qui m'a suivi pas à pas dans la construction du bâtiment.",
        "Mélanie qui a élaboré le logo «Au 4A».",
        "Roma qui a su figer l'endroit à son avantage avec ces magnifiques photos.",
        "Hughes Wautelet, mon fournisseur de vins et ami de la Table Ronde.",
        "Olivier Lemmens pour la petite touche aquatique.",
        "La Table Ronde d'Andenne 99 pour son soutien à différentes associations. En particulier, Au Fil de l'Eau, au service des personnes handicapées.",
        "Sans oublier, Pierre-Yves Dienst, le concepteur de ce site et sa charmante épouse, Fabienne."
      ],
      artists_intro: "Les différents artistes qui m'ont inspiré, donné l'envie et surtout régalé:",
      artists: [
        "Jean-Luc et Sabine à Wanze: La Gastronomie du Mayeur",
        "Patrick et Manu à Thon (Andenne): Les Jardins de mon Père",
        "Johann et Marion à Bas-Oha (Wanze): Le Champerdrix",
        "Manu et Sophie à Huy: La Petite Cour",
        "Arabelle et Pierre à Marchin (Huy): Li Cwerneu."
      ]
    }, */

  gallery: [
    {
      category: "Plats",
      images: [
        { src: "/assets/gallery/plat1.jpg" },
        { src: "/assets/gallery/plat2.jpg" },
        { src: "/assets/gallery/plat3.jpg" },
        { src: "/assets/gallery/plat4.jpg" },
        { src: "/assets/gallery/plat5.jpg" },
        { src: "/assets/gallery/plat6.jpg" },
        { src: "/assets/gallery/plat7.jpg" },
        { src: "/assets/gallery/plat8.jpg" },
        { src: "/assets/gallery/plat9.jpg" },
        { src: "/assets/gallery/plat10.jpg" },
        { src: "/assets/gallery/plat11.jpg" },
        { src: "/assets/gallery/plat12.jpg" },
        { src: "/assets/gallery/plat13.jpg" },
        { src: "/assets/gallery/plat14.jpg" },
        { src: "/assets/gallery/plat15.jpg" },
        { src: "/assets/gallery/plat16.jpg" },
        { src: "/assets/gallery/plat17.jpg" },
        { src: "/assets/gallery/plat18.jpg" },
        { src: "/assets/gallery/plat19.jpg" },
        { src: "/assets/gallery/plat20.jpg" },
        { src: "/assets/gallery/plat21.jpg" },
        { src: "/assets/gallery/plat22.jpg" },
        { src: "/assets/gallery/plat23.jpg" },
        { src: "/assets/gallery/plat24.jpg" },
        { src: "/assets/gallery/plat25.jpg" },
        { src: "/assets/gallery/plat26.jpg" },
        { src: "/assets/gallery/plat27.jpg" },
        { src: "/assets/gallery/plat28.jpg" },
        { src: "/assets/gallery/plat29.jpg" },
        { src: "/assets/gallery/plat30.jpg" },
      ],
    },
    {
      category: "Restaurant",
      images: [
        { src: "/assets/gallery/resto1.jpg" },
        { src: "/assets/gallery/resto2.jpg" },
        { src: "/assets/gallery/resto3.jpg" },
        { src: "/assets/gallery/resto4.jpg" },
        { src: "/assets/gallery/resto5.jpg" },
        { src: "/assets/gallery/resto6.jpg" },
        { src: "/assets/gallery/resto7.jpg" },
        { src: "/assets/gallery/resto8.jpg" },
        { src: "/assets/gallery/resto9.jpg" },
        { src: "/assets/gallery/resto10.jpg" },
        { src: "/assets/gallery/resto11.jpg" },
        { src: "/assets/gallery/resto12.jpg" },
        { src: "/assets/gallery/resto13.jpg" },
        { src: "/assets/gallery/resto14.jpg" },
        { src: "/assets/gallery/resto15.jpg" },
        { src: "/assets/gallery/resto16.jpg" },
      ],
    },
    {
      category: "Evenements",
      images: [
        { src: "/assets/gallery/event1.jpg" },
        { src: "/assets/gallery/event2.jpg" },
        { src: "/assets/gallery/event3.jpg" },
        { src: "/assets/gallery/event4.jpg" },
        { src: "/assets/gallery/event5.jpg" },
      ],
    },
  ],
};
